var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.1833V14.1301C15.5 14.5676 15.1617 14.9306 14.7254 14.9614C14.3609 14.9872 14.0636 15 13.8333 15C6.4695 15 0.5 9.0305 0.5 1.66667C0.5 1.43642 0.512875 1.13906 0.538625 0.774583C0.569475 0.338233 0.93245 0 1.36988 0H4.31675C4.53065 0 4.7098 0.162017 4.73127 0.374833C4.75056 0.565892 4.76848 0.719283 4.78506 0.835017C4.95362 2.01227 5.29794 3.1328 5.79058 4.16919C5.86966 4.33554 5.81809 4.53466 5.66821 4.64172L3.86962 5.9265C4.9646 8.48425 7.01575 10.5354 9.5735 11.6304L10.8559 9.83492C10.9643 9.68325 11.1658 9.63108 11.3342 9.711C12.3705 10.2032 13.4909 10.5472 14.668 10.7153C14.783 10.7318 14.9354 10.7496 15.1252 10.7687C15.338 10.7902 15.5 10.9694 15.5 11.1833Z",
    fill: "#2C2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFilled);
export default __webpack_public_path__ + "static/media/phone-filled.d7591d09574117c0c966258ae8cf623c.svg";
export { ForwardRef as ReactComponent };